import { ReactNode } from 'react';
import cn from 'classnames';

import styles from './Header.module.scss';

export type CardHeaderProps = {
  children: ReactNode;
  size?: 'small' | 'medium' | 'large';
  background?: 'white' | 'grey' | 'green' | 'red';
};

const CardHeader = ({ children, size = 'medium', background }: CardHeaderProps) => (
  <div className={cn(styles.root, styles[size], background ? styles[background] : '')}>
    {children}
  </div>
);

export default CardHeader;
